export const storePublicIndex = (state, publicIndex) => {
    // Vue.set  makes the change reactive!!
    state.publicIndex = publicIndex;
};
